// collections.js
export const collectionNames = [
  "purrtardio_collection"
];
